module.exports = __webpack_public_path__ + "static/media/scribbles.7f81fdc7.png";